// extracted by mini-css-extract-plugin
module.exports = {"button":"button__2mAjQ","icon":"icon__GPbKV","wrapEmail":"wrapEmail__13mTS"};